import React from "react";
import {Button, Card, notification, Row, Upload} from "antd";
import {API_BASE_URL, ASSET_BASE_URL} from "../../configs/AppConfig";
import {InboxOutlined, FileImageOutlined, DeleteOutlined} from "@ant-design/icons";


export default function ImageUploadField(props) {
    var value = props.value


    if (!value) {
        return (
            <Upload.Dragger
                name="image"
                multiple={false}
                accept="image/*"
                showUploadList={false}
                onChange={({file}) => {
                    if (file.response && file.status === "done") {
                        if (props.maxSize && file.size > props.maxSize) {
                            notification.error({
                                message: "Le fichier " + file.name + " est trop volumineux"
                            })
                            return false
                        }

                        props.onChange(file.response)
                    }
                }}
                headers={{authorization: localStorage.getItem("AUTH_TOKEN")}}
                action={API_BASE_URL + "/upload/image?autoValide=1"}
            >
                <p className="ant-upload-drag-icon">
                    <FileImageOutlined/>
                </p>
                <p className="ant-upload-text">Cliquez ou faites glisser le fichier vers cette zone pour le
                    télécharger</p>
                <p className="ant-upload-hint">PNG / JPG</p>
                {props.text && (
                    <p className="ant-upload-hint">{props.text}</p>
                )}
            </Upload.Dragger>
        )
    }

    const image = value.startsWith("https://") ? value : ASSET_BASE_URL + "/" + value


    return (
        <Row style={{justifyContent: "flex-start", alignItems: "flex-start"}}>
            <img src={image}
                 style={{maxWidth: 150, maxHeight: "30%", marginRight: 8, ...props.imageStyle}} onError={(e) => {
                const path = API_BASE_URL + "/upload/tmp/" + value
                if (e.target.src !== path) {
                    e.target.src = path
                }
            }}
            />
            <Button type="danger" icon={<DeleteOutlined/>} onClick={() => {
                props.onChange(null)
            }}/>
        </Row>
    )
}
